import { lead } from './lead';
import meta from './jobaffairs.meta.json';
import type { Brand } from './types';

const logoMark = '/brands/jobaffairs/favicon.svg';
const logoWordmark = '/brands/jobaffairs/logo.svg';

export const jobaffairs: Brand = {
  ...lead,
  key: 'jobaffairs',
  name: meta.name,
  shortName: meta.name,
  emblem: 'ONE',
  productName: meta.name,
  productBadge: 'JA',
  legalName: 'Jobaffairs',
  byline: null,
  logos: { main: logoWordmark, text: logoWordmark, panel: logoMark, panelInvert: false },
  wordmark: { light: 'Job affairs', bold: 'ONE' },
  assetDir: '/brands/jobaffairs/',
  font: {
    family: "Montserrat, 'Avenir Next', 'Segoe UI', system-ui, sans-serif",
    file: '/brands/jobaffairs/montserrat-latin.woff2',
  },
  theme: {
    primary: meta.themeColor,
    primaryHover: '#0b2d5e',
    primarySoft: '#e6ebf3',
    accent: '#e5a023',
    accentOnDark: '#f2c46b',
    accentHover: '#cf8c12',
    accentText: '#001d45',
    sidebarBg: '#0a1428',
    panelBg: '#0a1428',
    sidebarLink: '#afc3e8',
    // pageBg: '#f1eee8',
    text: '#1b1e25',
    border: '#e3dfd7',
  },
  legalLinks: {
    imprint: 'https://jobaffairs.at/impressum/',
    privacy: 'https://jobaffairs.at/datenschutz/',
    terms: 'https://jobaffairs.at/wp-content/uploads/sites/18/2017/06/Jobaffairs-AGB-UND-DATENSCHUTZERKLAERUNG.pdf',
  },
};
